import { render } from "./KeywordsInput.vue?vue&type=template&id=3ea43206"
import script from "./KeywordsInput.vue?vue&type=script&lang=js"
export * from "./KeywordsInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__